export class Confirm {
    text: string;
    siFn() {
    }
    noFn() {
    }
}